import { COMPANY_INFO, LOGO_IMAGE } from "../data/mock";
import { Mail, Globe, Building2, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-[#0A1628] text-white overflow-hidden">
      <div className="h-1 bg-gradient-to-r from-[#0049B3] via-[#FFC72C] to-[#0049B3]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_IMAGE} alt="Agent ŠVP" className="h-10 w-auto" />
            </div>
            <p className="text-sm text-blue-200/50 leading-relaxed">Inteligentní AI aplikace pro tvorbu ŠVP základních a mateřských škol v souladu s RVP 2025.</p>
          </div>
          <div>
            <h4 className="text-sm font-bold text-blue-200/70 uppercase tracking-wider mb-6">Navigace</h4>
            <div className="space-y-3">
              {[
                { label: "Základní školy", href: "/zakladni-vzdelavani", isPage: true },
                { label: "Mateřské školy", href: "/predskolni-vzdelavani", isPage: true },
                { label: "Časté dotazy", href: "/#faq", isPage: true },
                { label: "Kontakt", href: "/#kontakt", isPage: true },
                { label: "Živé ukázky", href: "/#webinar", isPage: true }
              ].map((link) => (
                <Link key={link.href} to={link.href} className="block text-sm text-blue-200/40 hover:text-[#FFC72C] transition-colors duration-300">{link.label}</Link>
              ))}
              <Link to="/podpora" className="block text-sm text-blue-200/40 hover:text-[#FFC72C] transition-colors duration-300">Podpora</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-bold text-blue-200/70 uppercase tracking-wider mb-6">Kontakt</h4>
            <div className="space-y-4">
              <a href={`tel:${COMPANY_INFO.phone.replace(/\s/g, '')}`} className="flex items-center gap-3 text-sm text-blue-200/40 hover:text-[#FFC72C] transition-colors"><Phone className="w-4 h-4 flex-shrink-0" /><span>{COMPANY_INFO.phone}</span></a>
              <a href={`mailto:${COMPANY_INFO.email}`} className="flex items-center gap-3 text-sm text-blue-200/40 hover:text-[#FFC72C] transition-colors"><Mail className="w-4 h-4 flex-shrink-0" /><span>{COMPANY_INFO.email}</span></a>
              <a href={`https://${COMPANY_INFO.web}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-blue-200/40 hover:text-[#FFC72C] transition-colors"><Globe className="w-4 h-4 flex-shrink-0" /><span>{COMPANY_INFO.web}</span></a>
              <div className="flex items-start gap-3 text-sm text-blue-200/40"><MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" /><div><p>{COMPANY_INFO.address}</p><p className="mt-1">{COMPANY_INFO.address2}</p></div></div>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-bold text-blue-200/70 uppercase tracking-wider mb-6">Provozovatel</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-blue-200/40"><Building2 className="w-4 h-4 flex-shrink-0" /><span>{COMPANY_INFO.name}</span></div>
              <div className="text-sm text-blue-200/40">IČO: {COMPANY_INFO.ico}</div>
            </div>
          </div>
        </div>
        <div className="py-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-blue-200/30">© {currentYear} {COMPANY_INFO.name}. Všechna práva vyhrazena.</p>
          <div className="flex items-center gap-6">
            <Link to="/ochrana-udaju" className="text-xs text-blue-200/30 hover:text-blue-200/60 transition-colors">Ochrana osobních údajů</Link>
            <Link to="/obchodni-podminky" className="text-xs text-blue-200/30 hover:text-blue-200/60 transition-colors">Obchodní podmínky</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
